import {WEEK} from '@wandb/weave/common/util/time';

export const MOBILE_BREAKPOINT_PX = 768;

export function isWithinLastWeek({timeMS}: {timeMS: number}): boolean {
  return Date.now() - timeMS <= WEEK;
}
